import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, Typography, Paper } from '@mui/material';
import { motion } from 'framer-motion';

const UnauthorizedMessage = () => (
  <Box
    component={motion.div}
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '80vh',
      p: 3
    }}
  >
    <Paper
      elevation={3}
      sx={{
        p: 4,
        maxWidth: 500,
        textAlign: 'center'
      }}
    >
      <Typography variant="h5" color="error" gutterBottom>
        Unauthorized Access
      </Typography>
      <Typography variant="body1" color="text.secondary">
        You don't have permission to access this page. Please contact your administrator if you believe this is a mistake.
      </Typography>
    </Paper>
  </Box>
);

const ProtectedAdminRoute = ({ children }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (user.role !== 'admin') {
    return <UnauthorizedMessage />;
  }

  return children;
};

export default ProtectedAdminRoute; 